module.exports = __webpack_public_path__ + "static/textinput-helptext-do-2a60720ab4db38e8ec5e8b6efd0064ec.png";